import { useAskQuestionQuery } from 'store/slices/aiInsights-api';
import { useAiInsightsContext } from './useAiInsightsContext';

interface UseAskQuestionRequestParams {
  question: string;
  pageName: string;
}

export const useAskQuestionRequest = ({
  question,
  pageName,
}: UseAskQuestionRequestParams) => {
  const {
    currencyCode,
    currencySymbol,
    availableAssets,
    assetBreakdown,
    portfolioSummary,
    isLoadingRequiredData,
    productCodesAndNames,
  } = useAiInsightsContext();

  const {
    data: questionData,
    isLoading: isLoadingQuery,
    isFetching: isFetchingQuery,
    refetch,
  } = useAskQuestionQuery(
    {
      question,
      pageName,
      configurations: {
        timeFrameInDays: 1,
        currencyCode,
        currencySymbol,
      },
      availableAssets,
      assetBreakdown,
      portfolioSummary,
    },
    {
      skip: isLoadingRequiredData,
    },
  );

  const isLoading = isLoadingRequiredData || isLoadingQuery || isFetchingQuery;
  return {
    questionData,
    isLoading,
    refetch,
    productCodesAndNames,
  };
};

